import { asPage } from 'src/components/hoc/asPage'
import { RequestBoxPage } from 'src/compositions/RequestBox'

export default asPage(RequestBoxPage, { pageTitle: 'つながり一覧' })
